import type { AiAction } from "@/integrations/multiresume/quota/types";

type AiEditQuotaTarget = {
  type: "summary" | "experience" | "project";
};

export function getAiEditQuotaAction(target: AiEditQuotaTarget): AiAction {
  if (target.type === "summary") return "phase5.section_regenerate.v1";
  return "phase5.item_regenerate.v1";
}
